import { DateTimePicker } from "@mui/x-date-pickers";
import EnderecoEdit from "components/endereco/EnderecoEdit";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Endereco from "model/transportes/endereco/Endereco";
import ItemRota from "model/transportes/rota/ItemRota";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import RotaService from "service/transportes/RotaService";
import { converterDataHora } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: (item: ItemRota) => void;
    value: ItemRota | null;
}

const rotaService = new RotaService();
export default function ModalItemRota(props: Props) {

    const [item, setItem] = useState<ItemRota>(props.value ? props.value : new ItemRota());

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
        <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={() => props.onConfirm(item)} />
    </div>

    return (
        <Dialog header="Item da rota" visible={props.visible} baseZIndex={100} style={{ width: '1000px' }} onHide={props.onHide} footer={footer}>

            <TabView>
                <TabPanel header="Dados" >
                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                        <div className="col-sm-12">
                            <Dropdown options={rotaService.getListTipoItem()}
                                optionLabel="label" optionValue="value"
                                disabled={item.tipo === "ENTREGA"}
                                optionDisabled={(option) => option.value === 'ENTREGA' && item.coleta === null}
                                onChange={(e) => {
                                    setItem({ ...item, tipo: e.value })
                                }}
                                value={item.tipo}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Data Prevista</Label>
                        <div className="col-sm-12">
                            <DateTimePicker
                                sx={{ width: '300px' }}
                                value={dayjs(item.dataPrevista)}
                                ampm={false}
                                format={"DD/MM/YYYY HH:mm"}
                                onChange={value => {
                                    setItem({ ...item, dataPrevista: value?.toDate() || null })
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Data Realizada</Label>
                        <div className="col-sm-12">
                            <InputText style={{ width: "300px" }} disabled value={converterDataHora(item.dataRealizada)} />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Observação</Label>
                        <div className="col-sm-12">
                            <InputTextarea style={{ width: "300px" }} value={item.observacao} onChange={(e) => setItem({ ...item, observacao: e.target.value })} />
                        </div>
                    </div>
                    {item.tipo === 'COLETA' &&
                        <div style={{ marginTop: 8 }}>
                            {item.coleta ? <div style={{ display: "flex", flexDirection: "column", rowGap: 2 }}>
                                <h4>Dados da coleta</h4>
                                <span><strong>Número da coleta: </strong>{item.coleta.numero}</span>
                                <span><strong>Data prevista: </strong>{converterDataHora(item.coleta.dataPrevista)} </span>
                                <span><strong>Cliente: </strong>{item.coleta.cliente?.nome}</span>
                                <span><strong>Estado: </strong>{item.coleta.endereco.estado}</span>
                                <span><strong>Cidade: </strong>{item.coleta.endereco.cidade}</span>
                            </div> : null}
                        </div>
                    }

                </TabPanel>
                <TabPanel header="Endereço" >
                    <EnderecoEdit value={item.endereco || new Endereco()} onChange={(endereco) => setItem({ ...item, endereco: endereco })} />
                </TabPanel>
            </TabView>

        </Dialog>
    )
}